export const STUDIO_PRODUCTION_HOST = 'studio.tryiris.ai';
